import debounce from "lodash.debounce";
import {
  activeFilter,
  inullFilter,
  nameFilter
} from "../../../../services/FilteringUtils";
import CommonUtil from "../../../../utils/CommonUtil";
import TreeComponent from "../TreeComponent";

class SearchableTreeComponent extends TreeComponent {
  constructor(props) {
    super(props);

    this.state = this.initialState();

    this.onSearchChangeDebounced = debounce(this.onSearchChangeDebounced, 500);
  }

  initialState() {
    return {
      ...super.initialState(),
      searchValue: ""
    };
  }

  initialPageInfo() {
    return {
      ...super.initialPageInfo(),
      filters: {
        ...activeFilter,
        ...this.getSearchFilter(),
        modelParentId: inullFilter //transfer to correct container - not a valid place
      }
    };
  }

  getSearchFilter() {
    return CommonUtil.jsonCopy(nameFilter);
  }

  onSearchChangeDebounced = searchValue => {
    let pageInfo = this.state.pageInfo;
    pageInfo.number = 0;
    pageInfo = this.createSearchInfo(searchValue, pageInfo);
    this.startLoading(pageInfo);
  };

  onSearchChange = e => {
    const searchValue = e.target.value;
    this.setState({ searchValue });
    this.onSearchChangeDebounced(searchValue);
  };

  renderProps() {
    return {
      ...super.renderProps(),
      onSearchChange: this.onSearchChange,
      searchValue: this.state.searchValue
    };
  }
}

export default SearchableTreeComponent;
